export const screenBreakpoints = {
  xxsmall: '30em' /* 480 / 16 */,
  xsmall: '45em' /* 720 / 16 */,
  small: '60em' /* 960 / 16 */,
  medium: '64em' /* 1024 / 16 */,
  large: '80em' /* 1280 / 16 */,
  xlarge: '120em' /* 1920 / 16 */,
};
